"use strict";

exports.__esModule = true;
exports.updateSimplifiedSeoTag = void 0;

var _updateBySchema = require("../values/update-by-schema");

var _TagSchemas = require("../../types/TagSchemas");

var updateSimplifiedSeoTag = function updateSimplifiedSeoTag(advancedSeoData, simplifiedTag, value) {
  var tags = advancedSeoData.tags;

  var tagSchema = _TagSchemas.TAG_SCHEMAS[simplifiedTag.generalIdentifier](simplifiedTag.label);

  var updatedTags = (0, _updateBySchema.updateValueBySchema)(tags, tagSchema, value);
  return updatedTags;
};

exports.updateSimplifiedSeoTag = updateSimplifiedSeoTag;